module.exports = __webpack_public_path__ + "img/dd-logo-kia-w.28bdff64.png";